<template lang="pug">
div(class="flex flex-wrap -mx-3 bg-white")
    div(
        v-if="imageUrl"
        class="p-3 w-full lg:w-1/3"
    )
        img(
            :src="imageUrl"
            :alt="imageAlt"
            class="mx-auto"
        )

    div(class="p-3 w-full lg:flex-1 text-center")
        h3 Well That's A Bummer...

        p(class="mb-5") {{ subtext }}

        BaseButton(
            color="WARNING"
            v-if="$route.name.indexOf('-mmy') > -1"
            @click.native="clearFitment"
            class="mx-1"
            style="width: 200px;"
        ) Reset My Vehicle
        BaseButton(
            :to="{ name: 'home' }"
            class="mx-1"
            style="width: 200px;"
        ) Go To HomePage
</template>

<script>
import { linkBuilders } from '@/helpers/mixins'
import BaseButton from '@/components/baseButton'

export default {
    components: { BaseButton },
    mixins: [linkBuilders],
    computed: {
        fitmentFormatted() {
            return this.$store.getters['fitment/fitmentFormatted']
        },
        imageUrl() {
            return this.$storyblok.formatSrc(this.$sitewideData.styles.content.noResults?.filename)
        },
        imageAlt() {
            return this.$sitewideData.styles.content.noResults?.alt
        },
        subtext() {
            let text = "We don't"

            if (this.$route.name.includes('category'))
                text += ' carry any products in this category'
            else if (this.$route.name.includes('brand'))
                text += ' carry any products from this brand'
            else if (this.$route.name.includes('special')) text += ' have any products on sale'
            else if (this.$route.name.includes('search'))
                text += ' have any products that matched your search'
            else text += ' carry any products in this area'

            if (this.fitmentFormatted) text += ` for your ${this.fitmentFormatted}`

            text += '.'

            return text
        },
    },
    mounted() {
        this.$uiEvents.$emit('noResultsViewed', this.$route)
    },
    methods: {
        clearFitment() {
            this.$store.dispatch('fitment/clearFitment').then(() => {
                // TODO: Remember to redirect to homepage if you are on a YMM page -- once we have that crap ready
                this.$push.to(
                    this.linkBuilder({
                        name: this.$route.name,
                        params: Object.assign({ forceReload: true }, this.$route.params),
                    })
                )
            })
        },
    },
}
</script>
